<!--
 * @Autor: Baowang
 * @Date: 2024-11-18 18:00:16
 * @pageName: 主页面底部
 * @LastEditTime: 2024-11-21 17:55:29
-->
<template>
  <div class="publicBottom animate__animated animate__fadeInUp" v-if="configInfo">
    <div class="flex align-center justify-between publicBottom_content">
      <!-- 图标 -->
      <div class="publicBottom_image">
        <el-image class="image_one" :src="configInfo.logo_b" fit="fill" lazy></el-image>
      </div>
      <!-- 关于我们 -->
      <div class="publicBottom_aboutUs">
        <div class="aboutUs_title">{{ $t('public.gywm') }}</div>
        <div class="aboutUs_desc">
          {{ configInfo.about_us }}
        </div>
      </div>
      <!-- 公司信息 -->
      <div class="publicBottom_info">
        <div class="info_title">{{ $t('public.country') }}</div>
        <div class="info_name">{{ configInfo.company_name }}</div>
        <div class="info_address">{{ $t('public.address') }}：{{ configInfo.company_address }}</div>
        <div class="info_phone">{{ $t('public.phone') }}：{{ configInfo.tel }}</div>
      </div>
    </div>
    <!-- 小程序 -->
    <div class="publicBottom_icp">
      {{ $t('public.icp') }} {{ configInfo.beian }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      configInfo: null
    };
  },
  created() {
    this.getConfigData()
  },
  methods: {
    // 获取配置数据
    getConfigData() {
      this.$api({
        url: "/api/index/get_config",
        method: "post",
        data: {
        }
      }).then((res) => {
        this.configInfo = res.data
      })
    },
  },
};
</script>
<style lang="less" scoped>
.publicBottom {
  height: 270px;
  background-color: #030D26;
  padding: 0 360px;
  color: white;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;

  .publicBottom_content {
    height: 230px;
    border-bottom: 1px solid #f7f7f7;

    .publicBottom_image {
      .image_one {
        width: 160px;
        height: 113px;
      }
    }

    // 关于我们
    .publicBottom_aboutUs {
      width: 500px;
      padding: 0 20px;

      .aboutUs_title {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }

      .aboutUs_desc {
        font-size: 14px;
      }
    }

    // 信息
    .publicBottom_info {
      .info_title {
        font-weight: bold;
        font-size: 18px;
      }

      .info_name,
      .info_address,
      .info_phone {
        font-size: 14px;
        margin-top: 5px;
      }
    }
  }

  //   备案
  .publicBottom_icp {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
  }
}
</style>
